<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div>
        <div class="header-statement-contact">
            <h3>Contact Us</h3>
            <p>Have questions or ready to enhance your construction safety program? We're is here to help.</p>
        </div>
        <form class="grid-container-contact">
            <!-- <div class="item1">
                <div>
                    <span class="form-group">
                        <label>Full Name</label>
                        <input type="text" class="form-control" id="name" placeholder="John Doe" />
                    </span>
                    <span class="form-group">
                        <label>Company</label>
                        <input type="text" class="form-control" id="organization" placeholder="Your Company" />
                    </span>
                </div>
                <div>
                    <span class="form-group">
                        <label>Email</label>
                        <input type="text" class="form-control" id="email" placeholder="your.email@example.com" />
                    </span>
                    <span class="form-group">
                        <label>Phone</label>
                        <input type="phone-number" class="form-control" id="tel" placeholder="555-555-5555" />
                    </span>
                </div>
                <div style="font-weight: 600;">
                    <label>Subject</label>
                    <input type="text" class="form-control">
                </div>
                <div style="font-weight: 600;">
                    <label>Message</label>
                    <textarea type="text" class="form-control"></textarea>
                </div>


                <div class="my-3">
                    <button type="submit" class="btn btn-primary"
                        style="background-color:#0e5295;border:none;">Send Message</button>
                </div>
            </div> -->
            <div class="item2">
                <h3 style="color:#0e5295 ;">Contact Information</h3>
                <h4 style="margin-top: 4%;">Phone </h4>
                <p>(318) 381-9870</p>
                <h4 style="margin-top: 4%;">Email </h4>
                <p>jesse@icsafetysolutions.com</p>
                <h4 style="margin-top: 4%;">Hours</h4>
                <p>Monday - Friday: 8:00 AM - 5:00 PM</p>






            </div>

        </form>

    </div>

</template>
<script>
export default {};
</script>

<style>
.grid-container-contact {
    display: grid;
    grid-template-columns: auto;
    grid-gap: 3em;
    padding: 10px;
    width: 70vw;
    margin: 5% 15vw;
}

.header-statement-contact {
    text-align: center;
    font-family: ui-sans-serif, system-ui, sans-serif;
    background-color: #0e5295; 
    padding: 3% 0% 6%; 
    margin-top: 0%;
}
.header-statement-contact h3{
    font-size: 180%; 
    color: white;
}
.header-statement-contact p{
    font-size: 100%; 
    color: white; 
    max-width: 80%; 
    margin: 0% 20%;
}

.form-group {
    font-weight: 600;
    vertical-align: top;
    width: 48%;
    margin-right: 2%;
}
@media (min-width:640px){
    .grid-container-contact {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 3em;
    padding: 10px;
    width: 70vw;
    margin: 5% 15vw;
}

.header-statement-contact {
    text-align: center;
    font-family: ui-sans-serif, system-ui, sans-serif;
    background-color: #0e5295; 
    padding: 3% 0% 6%; 
    margin-top: 0%;
}
.header-statement-contact h3{
    font-size: 320%; 
    color: white;
}
.header-statement-contact p{
    font-size: 140%; 
    color: white; 
    max-width: 40%; 
    margin: 0% 30%;
}

.form-group {
    font-weight: 600;
    display: inline-block;
    vertical-align: top;
    width: 48%;
    margin-right: 2%;
    margin-top: 4%;
}
}
@media (min-width:1024px){
        .grid-container-contact {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 3em;
    padding: 10px;
    width: 70vw;
    margin: 5% 15vw;
}

.header-statement-contact {
    text-align: center;
    font-family: ui-sans-serif, system-ui, sans-serif;
    background-color: #0e5295; 
    padding: 3% 0% 6%; 
    margin-top: 0%;
}
.header-statement-contact h3{
    font-size: 320%; 
    color: white;
}
.header-statement-contact p{
    font-size: 140%; 
    color: white; 
    max-width: 40%; 
    margin: 0% 30%;
}

.form-group {
    font-weight: 600;
    display: inline-block;
    vertical-align: top;
    width: 48%;
    margin-right: 2%;
}
}
</style>